
 console.log('process.env.VUE_APP_TAG---666',process.env.VUE_APP_TAG)
import LOGIN from '@/axios/login/login'
import PERSONAL from '@/axios/personalSpace/personalSpace.js'
import { menu } from './menu'

const menuListStore = {
  // namespaced: true,
  state: () => ({
    menuList: sessionStorage.menuList
      ? JSON.parse(sessionStorage.menuList)
      : menu,
    editorTypeList: sessionStorage.editorTypeList
      ? JSON.parse(sessionStorage.editorTypeList)
      : [],
    //字典列表
    dictTypeList: sessionStorage.dictTypeList
      ? JSON.parse(sessionStorage.dictTypeList)
      : [],
    //menuList中的编辑器类别列表
    editorTypeArr: [],
  }),
  getters: {
    menuList: (state) => {
      return state.menuList
    },
    editorTypeArr: (state) => {
      let menuList = state.menuList,
        reg_editor = /(AI-T|海龟|基础积木|智能硬件|python|小智|小聪)/,
        editorTypeArr = []
      if (menuList && menuList.length > 0) {
        menuList.forEach((item) => {
          if (reg_editor.test(item.menuName)) {
            editorTypeArr.push(item)
          }
        })
      }
      // console.log('editorTypeArr',editorTypeArr)
      return editorTypeArr
    },
    editorTypeList: (state) => {
      return state.editorTypeList;
    },
    dictTypeList:(state)=>state.dictTypeList,
  },
  mutations: {
    getDataSetType(state, dictTypeCode) {
      var data = {
        dictTypeCode: dictTypeCode,
      }
      return PERSONAL.getComDictionary(data).then((result) => {
        if (result.isSuccess) {
          if (dictTypeCode == 'EditorType') {
            state.editorTypeList = result.data
            sessionStorage.editorTypeList = JSON.stringify(result.data)
          } else {
            state.dictTypeList = result.data
            sessionStorage.dictTypeList = JSON.stringify(result.data)
          }
        }
      })
    },

    getMenuList(state, val) {
      LOGIN.getMenuListByTenantId().then((res) => {
        if (res.isSuccess && res.data) {
          state.menuList = res.data
          sessionStorage.menuList = JSON.stringify(res.data)
        }
      })
    },
    initMenuList(state) {
      state.menuList = menu
    },
    setEditorTypeList(state, val) {
      state.editorTypeList = val
    },
  },

  actions: {
    getDataSetType({ commit, state }, { dictTypeCode }) {
      // console.log('dictTypeCode', dictTypeCode)
      commit('getDataSetType', dictTypeCode)
    },
    getMenuList({ commit, state }) {
      commit('getMenuList')
    },
    initMenuList({ commit, state }) {
      commit('initMenuList')
    },
    setEditorTypeList({ commit, state }, { editorTypeList }) {
      commit('setEditorTypeList', editorTypeList)
    },
  },
}

export default menuListStore
